import styled from 'styled-components';

export const StyleOverride = styled.div({
  body: {
    margin: 0,
  },
});
